export default "__VITE_ASSET__2eLNrjUW__"